import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const AvatarWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;

  @media ${({ theme }) => theme.media.tablet} {
    width: 120px;
    height: 120px;
  }
`;

export const StoryTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;

  @media ${({ theme }) => theme.media.tablet} {
    font-size: 28px;
  }
`;

export const StoryText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #444;
`;

export const StoryHighlight = styled.span`
  background-image: linear-gradient(
    ${({ theme }) => theme.palette.secondary}59,
    ${({ theme }) => theme.palette.secondary}59
  );
  background-repeat: no-repeat;
  background-position: 0 90%;
  background-size: 100% 48%;
  border-radius: 3px;
  font-weight: 700;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
`;
